// extracted by css-extract-rspack-plugin
export default {"glyph":"JTyFYi","poiGlyph":"yPHNyy"};